module.exports = __WEBPACK_EXTERNAL_MODULE_0__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"pakhshkit-js","commonjs2":"pakhshkit-js","amd":"pakhshkit-js","root":["pakhshkit","core"]}
// module id = 0
// module chunks = 0


// WEBPACK FOOTER //
// vanalytics/external {"commonjs":"pakhshkit-js","commonjs2":"pakhshkit-js","amd":"pakhshkit-js","root":["pakhshkit","core"]}